// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function HandsClappingIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M21 3V1a1 1 0 1 1 2 0v2a1 1 0 0 1-2 0Zm4.479 2.125a.988.988 0 0 0 .521.141 1 1 0 0 0 .855-.479l1-1.638a1 1 0 1 0-1.707-1.042l-1 1.638a1 1 0 0 0 .33 1.38Zm5.93 1.574a1 1 0 0 0-1.259-.645l-1.875.606a1 1 0 1 0 .614 1.904l1.875-.607a1 1 0 0 0 .645-1.263v.005Zm-3.75 4.992a9.964 9.964 0 0 1-1.574 12.059A10 10 0 0 1 7.811 26l-4.375-7.579a3.25 3.25 0 0 1 2.398-4.846l-.5-.867a3.25 3.25 0 0 1 2.291-4.833A3.25 3.25 0 0 1 9.05 3.954a3.256 3.256 0 0 1 3.851.447 3.25 3.25 0 0 1 5.485.224l1.5 2.599a3.25 3.25 0 0 1 5.398.347l2.375 4.12ZM14.49 6.875l.741 1.284c.248.226.459.489.625.78l1.5 2.594a3.275 3.275 0 0 1 2-1.223l-2.701-4.685a1.25 1.25 0 0 0-2.165 1.25Zm-4.898.519.742 1.285.04.036a3.242 3.242 0 0 1 2.09-1.348l-.707-1.223a1.25 1.25 0 1 0-2.165 1.25ZM24.2 23.07a7.951 7.951 0 0 0-.8-6.071l-2.375-4.114a1.25 1.25 0 0 0-2.218 1.148l1.428 2.466a1 1 0 1 1-1.734 1l-4.375-7.559a1.25 1.25 0 0 0-2.171 1.234l3.079 5.325a1 1 0 1 1-1.732 1L9.23 10.457a1.25 1.25 0 1 0-2.165 1.25l4.5 7.796a.999.999 0 0 1-1.475 1.293.998.998 0 0 1-.258-.293l-2.5-4.33a1.25 1.25 0 0 0-2.165 1.25L9.542 25a8 8 0 0 0 14.657-1.93Zm1.727-10.385-2.375-4.114a1.25 1.25 0 0 0-2.165 1.25l.739 1.282c.247.227.458.49.625.782L25.125 16a10.015 10.015 0 0 1 1.266 3.75 7.977 7.977 0 0 0-.465-7.064Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
